import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';
import { TipoTipologica } from "../../../../common/models/tipologiche/tipo-tipologica";

export class FascicoloDisciplina extends FascicoloFull {
  dataApertura: number;
  societa: SoggettoPratica;
  tipoContratto: TipoTipologica;
  tipoLavoratore: TipoTipologica;
  lavoratore: string;
  profiloProfessionale: TipoTipologica;
  impianto: TipoTipologica;
  sedeImpianto: TipoTipologica;
  tipoSanzione: TipoTipologica;
  dataProvvedimento: number;
  sospensioneCautelareNonDisciplinare: boolean;
  sospensioneRapportoDiLavoro: boolean;

  constructor() {
    super();
    this.dataApertura = + new Date();
    this.dataInizioFascicolo = + new Date();
  }
}
